import {post} from '@/api'
const moduleUser={
    state: {
       token: "",
       myStartDate:'',
       myEndDate:''
    },
    mutations: {
        setMyStartDate:(state,value)=>{
           state.myStartDate=value
        },
        setMyEndDate:(state,value)=>{
           state.myEndDate=value
        },
        SET_TOKEN:(state,payload)=>{
            state.token = payload.token;
        },
        LOG_OUT:(state)=>{
            state.token=""
            state.myStartDate=""
            state.myEndDate=""
        }
    },
    actions: {
        doLogin({commit},data){
            return new Promise((resolve,reject)=>{
                post("/login/doLogin",{mobile:data.mobile,password:data.password}).then((data)=>{
                    if(data.result.success){
                        commit("SET_TOKEN",{token:data.result.info.token})
                    }
                    resolve(data)
                }).catch((error)=>reject(error));
            }).catch(()=>{})
        }
    }
}

export default moduleUser